export interface Status {
  statusId: number;
  statusDesc: string;
}
